import { lazy } from 'react';

// Eager loading components
import Home from './home';
import Portfolio from './portfolio';
import Login from './Identity/login';
import Logout from './Identity/logout';

// Error Components
import DealsheetError from './dealsheet/error';
import NoDealsheetResult from './dealsheet/no-result';
import Error from './error';
import RobotException from './error/robot-exception';
import PageNotFound from './page-not-found';
import AuthError from './autherror';

// Incentive Advantage
const EUIDashboard = lazy(() => import('./essential-ui/dashboard'));
const EUIDealSheet = lazy(() => import('./essential-ui/dealsheet'));
const EUIDealHistory = lazy(() => import('./essential-ui/dealsheet/history'));

// Store Settings
const Admin = lazy(() => import('./admin/Admin'));
const AdminDashboard = lazy(() => import('./admin/dashboard'));
const CRMMapper = lazy(() => import('./admin/crm-mapper'));
const DataExport = lazy(() => import('./admin/data-export'));
const DMSMapper = lazy(() => import('./admin/dms-mapper'));
const HoursOfOperation = lazy(() => import('./admin/hours-of-operation'));
const OfferManager = lazy(() => import('./admin/offer-manager'));
const PreownedRates = lazy(() => import('./admin/preowned-rates'));
const Tradebooks = lazy(() => import('./admin/tradebooks'));
const UserManagement = lazy(() => import('./admin/user-management'));

// Mastermind Dealsheet
const DealSheet = lazy(() => import('./dealsheet'));
const DealSheetVin = lazy(() => import('./dealsheet'));
const BulkPrint = lazy(() => import('./bulk-print'));

// PWA
const PWA = lazy(() => import('./pwa'));
const DesktopModeError = lazy(() => import('./pwa/error/desktop-mode'));
const PwaError = lazy(() => import('./pwa/error'));
const Favorites = lazy(() => import('./pwa/favorites'));
const Recent = lazy(() => import('./pwa/recent'));
const Profile = lazy(() => import('./pwa/profile'));
const Support = lazy(() => import('./pwa/support'));
const GetMobileApp = lazy(() => import('./pwa/get-mobile-app'));

// Invitation
const Invitation = lazy(() => import('./invitation'));

// Reporting
const PerformanceInsights = lazy(() => import('./Reporting/performance-insights'));
const PrivateIncentiveInSights = lazy(() => import('./Reporting/private-incentive-insights'));
const ServicePortfolio = lazy(() => import('./Reporting/service-portfolio-insights'));

// Turn
const TurnPortfolio = lazy(() => import('./turn/portfolio'));
const TurnDetails = lazy(() => import('./turn/details'));

// Service Portfolio
const Service = lazy(() => import('./service'));

// Private Incentive Lookup
const PrivateIncentiveLookup = lazy(() => import('./private-incentive-lookup'));

// Acquire
const Acquire = lazy(() => import('./acquire'));

// Market Impact
const MarketImpact = lazy(() => import('./market-impact'));
const MarketImpactSummary = lazy(() => import('./market-impact-summary'));

// Digital Audience
const DigitalAudience = lazy(() => import('./digital-audience'));
const Accounts = lazy(() => import('./digital-audience/accounts'));
const AudienceBuilder = lazy(() => import('./digital-audience/audience-builder'));
const CustomAudience = lazy(() => import('./digital-audience/custom-audience'));
const ConnectAccount = lazy(() => import('./digital-audience/connect-account'));
const DigitalAudienceDashBoard = lazy(() => import('./digital-audience/dashboard'));
const Insights = lazy(() => import('./digital-audience/insights'));
const Reporting = lazy(() => import('./digital-audience/reporting'));

// Off IP
const OffIp = lazy(() => import('./offip'));

// Unauthorized
const Unauthorized = lazy(() => import('./unauthorized'));

// Carfax
const CarfaxCallBack = lazy(() => import('./carfax/CarfaxCallback'));

export {
  Accounts,
  Acquire,
  Admin,
  AdminDashboard,
  AudienceBuilder,
  AuthError,
  BulkPrint,
  CarfaxCallBack,
  ConnectAccount,
  CRMMapper,
  CustomAudience,
  DataExport,
  DealSheet,
  DealSheetVin,
  DealsheetError,
  DesktopModeError,
  DigitalAudience,
  DigitalAudienceDashBoard,
  DMSMapper,
  Error,
  EUIDashboard,
  EUIDealHistory,
  EUIDealSheet,
  Favorites,
  GetMobileApp,
  Home,
  HoursOfOperation,
  Insights,
  Invitation,
  Login,
  Logout,
  MarketImpact,
  MarketImpactSummary,
  NoDealsheetResult,
  OfferManager,
  OffIp,
  PageNotFound,
  PerformanceInsights,
  Portfolio,
  PreownedRates,
  PrivateIncentiveInSights,
  PrivateIncentiveLookup,
  Profile,
  PWA,
  PwaError,
  Recent,
  Reporting,
  RobotException,
  Service,
  ServicePortfolio,
  Support,
  Tradebooks,
  TurnDetails,
  TurnPortfolio,
  Unauthorized,
  UserManagement,
};
